import React, {useState} from 'react';
import {Box, Card, CardActions, CardContent, CardMedia, Divider, makeStyles, Typography, useTheme} from "@material-ui/core";
import {SecondaryButton} from "Components/Button";
import {BP_LARGE, BP_MEDIUM} from "Theme/breakpoints";
import {REWARDS_SCHEME_NAME} from "Setup/config";
import clsx from "clsx";
import StandaloneModal from "Components/Modal/Modals/standaloneModal";

export const useRewardsCardStyles = makeStyles(theme => {
    const CardSettings = theme.overrides.PromotionCard;
    const RewardsPageSettings = theme.overrides.RewardsPage;

    return {
        root: {
            borderRadius: CardSettings.borderRadius,
            background: RewardsPageSettings.infoCards.background,
            backdropFilter: CardSettings.backdropFilter,
            marginBottom: theme.spacing(3),
            [theme.breakpoints.up(BP_MEDIUM)]: {
                minHeight: 500,
                margin: theme.spacing(1),
            },
            maxWidth: 375,
            width: 320,
            transition: 'all .2s ease',
            transform: 'translateY(2px)',
            boxShadow: '0 -1px 1px 0 rgb(0 0 0 / 5%), 0 1px 3px 0 rgb(0 0 0 / 20%)',
            '& img': {
                height: 240,
                width: "auto",
                margin: "0 auto"
            },
            '&:hover': {
                transform: 'translateY(0px)',
                boxShadow: '0 4px 15px 0 rgb(0 0 0 / 30%), 0 0 1px 0 rgb(0 0 0 / 25%)'
            },
            '&.MuiPaper-root': {
                border: 'none'
            }
        },
        rewardsWrapper: {
            color: RewardsPageSettings.content.color,
            '& .MuiTypography-h4': {
                lineHeight: 'normal'
            }
        },
        cardWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            [theme.breakpoints.up(BP_LARGE)]: {
                flexDirection: 'row',
            },

        },
        cardAction: {
            justifyContent: "center",
            marginTop: 'auto',
            padding: theme.spacing(3),
            '& button': {
                width: '150px',
                color: RewardsPageSettings.infoCards.ctaColor,
                borderColor: RewardsPageSettings.infoCards.borderColor,
            }
        },
        cardInfo: {
            padding: theme.spacing(2),
            overflow: 'hidden',
            color: RewardsPageSettings.infoCards.color,
            '&.MuiCardContent-root:last-child': {
                paddingBottom: 0
            },
            '& .MuiTypography-h6': {
                lineHeight: 'normal'
            }
        },
        cardActionArea: {
            '&:hover': {
                background: 'transparent'
            }
        },
        description: {
            fontSize: 14
        }
    }
});

const RewardInfoCard = ({image, title, cardDescription, modalDescription}) => {
    const classes = useRewardsCardStyles();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const theme = useTheme();
    const {ctaVariant} = theme.overrides.PromotionCard.cardAction;

    return (
        <>
            <Card className={clsx(classes.root)}>
                <div className={classes.cardActionArea}>
                    <CardMedia
                        component={"img"}
                        title={title}
                        alt={image.alt ? image.alt : ""}
                        image={image.url ? image.url : "https://via.placeholder.com/320x240/115F65"}
                    />
                    <CardContent className={classes.cardInfo}>
                        <Typography gutterBottom component="h3" variant="h6">{title}</Typography>
                        <Typography className={classes.description} dangerouslySetInnerHTML={{__html: cardDescription}} paragraph/>
                    </CardContent>
                </div>
                <CardActions className={classes.cardAction}>
                    <SecondaryButton variant="outlined" onClick={() => setIsModalOpen(true)}>Read More</SecondaryButton>
                </CardActions>
            </Card>
            {isModalOpen &&
                <StandaloneModal title={title} onClose={() => setIsModalOpen(false)}>
                    <Typography dangerouslySetInnerHTML={{__html: modalDescription}}/>
                </StandaloneModal>
            }
        </>
    )
};

export const RewardsInfo = ({infoPromos = []}) => {
    const classes = useRewardsCardStyles();
    if (!infoPromos.length) return null;

    return (
        <Box mt={5} className={classes.rewardsWrapper}>
            <Divider/>
            <Box pt={6}>
                <Box textAlign="center">
                    <Typography paragraph gutterBottom variant="h5">How does the {REWARDS_SCHEME_NAME} programme work?</Typography>
                </Box>
                <Box className={classes.cardWrapper}>
                    {infoPromos.map((promo => {
                        return (
                            <RewardInfoCard
                                key={`card-${promo.id}`}
                                image={promo.images.default}
                                title={promo.displayName}
                                cardDescription={promo.description}
                                modalDescription={promo.detailedDescription}
                            />
                        );
                    }))}
                </Box>
            </Box>
        </Box>
    );
}
